import React, { Component, ComponentElement } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";

import "./ConfigurationStepper.component.scss";

import { configurationsStoreSelectors } from "../../../../store/store";
import { ValidConfigurationState } from "../../../../reducers/configFormValid.reducer";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { ActionCreator } from "../../../../../../actions/actions";

export interface ConfigurationStepperProps extends RouteComponentProps {
    pages: {
        id: string;
        name: string;
        component: ComponentElement<any, any>;
        valid?: boolean;
    }[];
    configFormValid: ValidConfigurationState;
    configFormVisited: ValidConfigurationState;
    stepperIsEditing: ActionCreator;
    selectedPage: string;
    onSelect: (...args: any) => any;
}

export interface ConfigurationStepperState {
    pages: {
        id: string;
        name: string;
        component: ComponentElement<any, any>;
        valid?: boolean;
    }[];
    isEditing: boolean;
}

class ConfigurationStepper extends Component<
    ConfigurationStepperProps,
    ConfigurationStepperState
> {
    constructor(props) {
        super(props);

        const isEditing =
            this.props.match.params &&
            this.props.match.params["editingServer"] &&
            this.props.match.params["editingConfig"];

        const isUploading =
            this.props.match.params &&
            this.props.match.params["uploadingServer"];

        this.state = {
            pages: this.props.pages,
            isEditing
        };

        if (isEditing || isUploading) {
            this.props.stepperIsEditing();
        }
    }

    renderStepperItems() {
        return this.state.pages.map(page => {
            let itemClass =
                "configuration-sidebar-item" +
                (this.props.selectedPage["id"] === page.id
                    ? " configuration-sidebar-item-selected"
                    : "");

            itemClass = `${itemClass} ${
                this.props.configFormVisited[page.id]
                    ? "config-sidebar-visited"
                    : ""
            }
                ${
                    this.props.configFormValid[page.id]
                        ? "config-sidebar-valid"
                        : "config-sidebar-invalid"
                }`;

            return (
                <div
                    key={page.id}
                    className={itemClass}
                    onClick={() => this.select(page)}
                >
                    <div>{page.name}</div>
                </div>
            );
        });
    }

    select = page => {
        this.props.onSelect && this.props.onSelect(page);
    };

    checkValid = _.memoize(({ configFormValid }) => {
        const valid = {
            settings: false,
            accounting: false,
            groups: false,
            progressives: false,
            specialPrizes: false,
            mailingList: false,
            ...configFormValid
        };

        return Object.values(valid).every(value => value === true);
    });

    render() {
        const current = _.findIndex(this.state.pages, {
            id: this.props.selectedPage["id"]
        });
        return (
            <div id="ConfigurationStepper">
                <div className="configuration-sections">
                    <span>
                        Step {current + 1} of {this.state.pages.length}
                    </span>
                    <p>{this.state.pages[current].name}</p>
                    <div className="steps">{this.renderStepperItems()}</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    configFormValid: configurationsStoreSelectors.configFormValid(state),
    configFormVisited: configurationsStoreSelectors.configFormVisited(state)
});

const mapDispatchToProps = {
    stepperIsEditing: ConfigurationsActionCreators.stepperIsEditing
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ConfigurationStepper));
